export default __webpack_public_path__ + "static/media/adobe-tech-3.2d7212ca.webp";